// extracted by mini-css-extract-plugin
module.exports = {"ulist":"StrapiRichText_ulist__2oKSX","olist":"StrapiRichText_olist__B1BfV"};